import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

const STATUSES = ["pending", "approved", "blocked"];

export default function AdminRetailers() {
  const [items, setItems] = useState([]);
  const [orders, setOrders] = useState([]);
  const load = async () => {
    const [r, o] = await Promise.all([api.get("/admin/retailers"), api.get("/admin/retailer-orders")]);
    setItems(r.data || []); setOrders(o.data || []);
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => { await api.put(`/admin/retailers/${id}/status`, { status }); toast.success(`Set ${status}`); load(); };
  const setOrderStatus = async (id, status) => { await api.put(`/admin/retailer-orders/${id}/status`, { status }); toast.success(`Order ${status}`); load(); };

  return (
    <div data-testid="admin-retailers" className="space-y-10">
      <header>
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Retailer Portal</div>
        <h1 className="editorial-h1 text-5xl mt-2">{items.length} retailers · {orders.length} orders.</h1>
      </header>

      <section>
        <div className="font-display text-2xl mb-4">Retailer accounts</div>
        <div className="card-elevated overflow-x-auto">
          <table className="w-full text-sm" data-testid="ret-table">
            <thead className="text-left text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">
              <tr className="border-b border-brand-line"><th className="p-4">Business</th><th className="p-4">Contact</th><th className="p-4">City</th><th className="p-4">Status</th><th className="p-4">Joined</th></tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id} className="border-b border-brand-line last:border-0" data-testid={`ret-row-${r.id}`}>
                  <td className="p-4"><div className="font-medium">{r.business_name}</div><div className="text-xs text-brand-charcoal/55">{r.gst_number || "no GST"}</div></td>
                  <td className="p-4"><div>{r.contact_name}</div><div className="text-xs text-brand-charcoal/55">{r.email} · {r.phone}</div></td>
                  <td className="p-4">{r.city}, {r.state}</td>
                  <td className="p-4">
                    <select data-testid={`ret-status-${r.id}`} className="text-xs border border-brand-line rounded-full px-2 py-1 bg-white" value={r.status || "pending"} onChange={(e) => setStatus(r.id, e.target.value)}>
                      {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </td>
                  <td className="p-4 text-xs text-brand-charcoal/55">{(r.created_at || "").slice(0, 10)}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-brand-charcoal/60">No retailer signups yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <div className="font-display text-2xl mb-4">Retailer orders</div>
        <div className="card-elevated overflow-x-auto">
          <table className="w-full text-sm" data-testid="ret-order-table">
            <thead className="text-left text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">
              <tr className="border-b border-brand-line"><th className="p-4">When</th><th className="p-4">Retailer</th><th className="p-4">Items</th><th className="p-4">Units</th><th className="p-4">Status</th></tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} className="border-b border-brand-line last:border-0">
                  <td className="p-4 text-xs text-brand-charcoal/65">{(o.created_at || "").slice(0, 10)}</td>
                  <td className="p-4"><div className="font-medium">{o.retailer_business}</div><div className="text-xs text-brand-charcoal/55">{o.retailer_email}</div></td>
                  <td className="p-4 max-w-md"><div>{o.items.map((i) => `${i.category}×${i.quantity}`).join(", ")}</div><div className="text-xs text-brand-charcoal/55 mt-1">{o.delivery_address}</div></td>
                  <td className="p-4">{o.total_units}</td>
                  <td className="p-4">
                    <select className="text-xs border border-brand-line rounded-full px-2 py-1 bg-white" value={o.status || "new"} onChange={(e) => setOrderStatus(o.id, e.target.value)}>
                      {["new","confirmed","shipped","delivered","cancelled"].map((x) => <option key={x} value={x}>{x}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
              {orders.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-brand-charcoal/60">No retailer orders yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
